import {ReportData} from "../../../reports/report.data";
import {field} from "@fedeltapointofsale/data-client";

export class TableReportData extends ReportData<TableReportData> {
    @field summary: boolean = true;
    @field exclusive: boolean = true;
    @field outletGroupId: number;
}
